import type { SupplierRfqRejectionReasonCode } from '../api/types'
import { REJECT_REASONS } from './ordersUtils'

type OrdersRejectReasonModalProps = {
  open: boolean
  reason: SupplierRfqRejectionReasonCode | null
  message: string
  actionLoading: boolean
  onSelectReason: (reason: SupplierRfqRejectionReasonCode) => void
  onMessageChange: (message: string) => void
  onConfirm: () => void
  onCancel: () => void
}

export const OrdersRejectReasonModal = ({
  open,
  reason,
  message,
  actionLoading,
  onSelectReason,
  onMessageChange,
  onConfirm,
  onCancel,
}: OrdersRejectReasonModalProps) => {
  if (!open) {
    return null
  }

  return (
    <div className="echat-modal" role="dialog" aria-modal="true" aria-labelledby="reject-title">
      <div className="echat-modal__backdrop" onClick={onCancel} />
      <div className="echat-modal__panel">
        <h3 id="reject-title" className="echat-modal__title">
          Причина отказа
        </h3>
        <p className="echat-modal__text">
          Ресторан увидит выбранную причину. При необходимости добавьте комментарий.
        </p>
        <div className="echat-chips" role="group" aria-label="Причины отказа">
          {REJECT_REASONS.map((option) => (
            <button
              key={option.code}
              type="button"
              className={reason === option.code ? 'echat-chip echat-chip--selected' : 'echat-chip'}
              aria-pressed={reason === option.code}
              onClick={() => onSelectReason(option.code)}
            >
              {option.label}
            </button>
          ))}
        </div>
        {reason ? (
          <label className="echat-field">
            <span className="echat-field__label">
              {reason === 'other' ? 'Комментарий (обязательно)' : 'Комментарий (необязательно)'}
            </span>
            <textarea
              className="echat-field__input"
              rows={3}
              maxLength={500}
              value={message}
              onChange={(event) => onMessageChange(event.target.value)}
              placeholder={
                reason === 'other' ? 'Опишите причину отказа' : 'Дополнительные детали для ресторана'
              }
            />
          </label>
        ) : null}
        <div className="echat-actions">
          <button
            type="button"
            className="echat-btn echat-btn--danger"
            disabled={actionLoading || !reason}
            onClick={onConfirm}
          >
            Отклонить заявку
          </button>
          <button type="button" className="echat-btn echat-btn--ghost" disabled={actionLoading} onClick={onCancel}>
            Отмена
          </button>
        </div>
      </div>
    </div>
  )
}
